import { db } from '../firebase';

const updateInvoices = async (userId, invoices) => {
  let error;
  const collectionRef = db.collection('users').doc(userId)
  try {
    await collectionRef.update({ invoices: invoices });
  } catch (error) {
    console.log(error)
  }
  return { error };

}

export default updateInvoices;